import React from 'react'
import './MainText.css'

const MainName = () => <span className="reverse-text">Zach Allen</span>
const MainPronoun = () => <span className="small-text">(He/Him).</span>

const getPartOfDayNoun = () => {
  const hour = new Date().getHours()
  return hour < 12 ? 'Morning' : hour < 17 ? 'Afternoon' : 'Evening'
}

const MainText = () => {
  return (
    <h1 className="text">
      Good {getPartOfDayNoun()}. <br />
      My name is <MainName /> <MainPronoun /> <br />
      I'm a full stack developer.
    </h1>
  )
}

export default MainText
